<script setup lang="ts">
interface IProps {
  title?: string
  text?: string
}

defineProps<IProps>()

const { colors } = useTheme()
</script>

<template>
  <div w="220px <md:265px" flex="~ col" mt="0 <md:60px">
    <div flex="~ col <md:row" items="start <md:center">
      <slot name="icon" />

      <Heading style="font-family: Circular Std Bold, sans-serif" level="2" mt="12px <md:0" ml="0 <md:10px">
        {{ title }}
      </Heading>
    </div>

    <Text flex style="font-family: Circular Std Book, sans-serif; line-height: 24px;" variant="normal" :color="colors.black" pt-15px>
      {{ text }}
    </Text>
  </div>
</template>
